export const TRACKING_EVENT_PENDING = 'TRACKING_EVENT_PENDING';
export const TRACKING_EVENT_SUCCESS = 'TRACKING_EVENT_SUCCESS';
export const TRACKING_EVENT_ERROR = 'TRACKING_EVENT_ERROR';
export const TRACKING_EVENT_CLICK = 'TRACKING_EVENT_CLICK';
export const TRACKING_EVENT_IMPRESSION = 'TRACKING_EVENT_IMPRESSION';
export const TRACK_EVENT = 'TRACK_EVENT';
